import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedSpecificAttribute, selectSpecificAttributesState, setAction } from "../redux/slices/specificAttributesSlice"
import { SpecificAttributesAPI } from "../apis/SpecificAttributesAPI"
import { SpecificAttribute } from "../types/slices/specificAttributesType"

export const useSpecificAttributeStore = () => {

    const dispatch = useDispatch()
    const { specificAttributes, specificAttributeSelected, status, action } = useSelector(selectSpecificAttributesState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getSpecificAttributes = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificAttributesAPI.getSpecificAttributes({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSpecificAttributesByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificAttributesAPI.getSpecificAttributesByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSpecificAttributesByAttribute = async (search='', idattribute:number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificAttributesAPI.getSpecificAttributesByAttribute({search:search, idattribute:idattribute, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createSpecificAttribute = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificAttributesAPI.createSpecificAttribute({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editSpecificAttribute = async (idattribute: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificAttributesAPI.editSpecificAttribute(idattribute, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteSpecificAttribute = async (idattribute: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SpecificAttributesAPI.deleteSpecificAttribute(idattribute)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedStore = (attribute: SpecificAttribute) => {
        try {
            dispatch(onSetSelectedSpecificAttribute(attribute))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionSpecificAttribute = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        specificAttributes,
        specificAttributeSelected,
        status,
        action,
        //actions
        getSpecificAttributes,
        getSpecificAttributesByCompany,
        getSpecificAttributesByAttribute,
        createSpecificAttribute,
        editSpecificAttribute,
        deleteSpecificAttribute,
        setSelectedStore,
        setActionSpecificAttribute,
    }
}